// extracted by mini-css-extract-plugin
export default {"version__container":"styles_version__container__6-7Th","version__text":"styles_version__text__Dujha"};